import { useTranslation } from '@kgc/i18n';
import type { FlowTab } from '../types';

interface FlowHealthWidgetProps {
  workflowCount: number;
  runningCount: number;
  pendingApprovalCount: number;
  scheduleCount: number;
  isOnline: boolean;
  onNavigate: (tab: FlowTab) => void;
}

export function FlowHealthWidget({
  workflowCount,
  runningCount,
  pendingApprovalCount,
  scheduleCount,
  isOnline,
  onNavigate,
}: FlowHealthWidgetProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center gap-3 text-xs text-muted-foreground flex-wrap"
      data-testid="flow-health-widget"
    >
      <span className="flex items-center gap-1">
        <span
          className={
            isOnline ? 'text-green-500 dark:text-green-400' : 'text-red-500 dark:text-red-400'
          }
        >
          ●
        </span>
        {isOnline ? t('integration.flow.health.ok') : t('integration.flow.health.offline')}
      </span>
      <span>
        ⚡ {workflowCount} {t('integration.flow.health.workflows')}
      </span>
      <button
        type="button"
        onClick={() => onNavigate('running')}
        className="hover:text-foreground transition-colors"
      >
        ▶ {runningCount} {t('integration.flow.health.running')}
      </button>
      <button
        type="button"
        onClick={() => onNavigate('approvals')}
        className="hover:text-foreground transition-colors"
      >
        ⏳ {pendingApprovalCount} {t('integration.flow.health.approvals')}
      </button>
      <span>
        ⏰ {scheduleCount} {t('integration.flow.health.schedules')}
      </span>
    </div>
  );
}
